import commonVars from "./_common.mjs";
const spaceDark = {
  name: 'Space',
  self() {
    return commonVars;
  }
};
export default spaceDark;